import React from 'react';
import { Grid, Button, Box, Typography } from '@mui/material';

const SignatureSection = ({ formData, handleSignatureOpen }) => {
  const staff = [
    { label: "Surgeon Signature", key: "surgeon" },
    { label: "Anesthesiologist Signature", key: "anesthesiologist" },
    { label: "Scrub Nurse Signature", key: "scrub_nurse" },
  ];

  return (
    <Box sx={{ mt: 4, pt: 4, borderTop: '2px dashed #008080' }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 3, fontWeight: 'bold' }}>
        Step 5: Final Signatures
      </Typography>
      
      <Grid container spacing={4}>
        {staff.map((person) => (
          <Grid item xs={12} sm={4} key={person.key}>
            <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#fafafa', textAlign: 'center' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#008080' }}>
                {person.label}
              </Typography>
              <Button
                variant="outlined"
                fullWidth
                color="primary"
                onClick={() => handleSignatureOpen(person.key)}
              >
                {formData.signature && formData.signature[person.key] ? 'Change Signature' : 'Provide Signature'}
              </Button>
              {formData.signature && formData.signature[person.key] && (
                <Box sx={{ mt: 2, border: "1px solid #ccc", p: 1, borderRadius: 1, backgroundColor: '#fff' }}>
                  <img src={formData.signature[person.key]} alt="Signature" style={{ maxHeight: '100px', maxWidth: '100%' }} />
                </Box>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SignatureSection;
